// Анимация прокрутки
window.AOS = require('aos/dist/aos');

// Красивый селект
//require('jquery-nice-select/js/jquery.nice-select');
